import { ReactMarkdown } from "react-markdown/lib/react-markdown"
import rehypeRaw from "rehype-raw"
import "./images-page.css"

interface Paragraph { text : string, image : string}

const ImagesPage = ( props : { title : string, paragraphs : Paragraph[] }) => {
    

    return  <div className="body-block">
        <h1>{props.title}</h1>
        {props.paragraphs.map( (par) => <div className="image-par">
            <div className="text-par"><ReactMarkdown rehypePlugins={[rehypeRaw]}>{par.text}</ReactMarkdown></div>
            <img src={par.image} title=""/>
        </div>)}
    </div>
}

export default ImagesPage;